import { useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSnapCarousel } from 'react-snap-carousel';
import { FaAngleLeft, FaAngleRight } from 'react-icons/fa6';
import Dropdown from '../../components/dropdown/Dropdown';
import ScreenToggleButton from '../../components/screen-toggle-button/ScreenToggleButton';
import MainNorth from '../../components/main/main-north/MainNorth';
import NorthExit from '../../components/main/main-north-exit/NorthExit';
import Stage from '../../components/main/stage/Stage';
import MainSouth from '../../components/main/main-south/MainSouth';
import MainWest from '../../components/main/main-west/MainWest';
// import './MainRoom.styles.scss';

const MainRoom = () => {
  const location = useLocation();

  const {
    scrollRef,
    pages,
    goTo,
    prev,
    next,
    activePageIndex,
  } = useSnapCarousel();

  const labels = ['NORTH', 'NORTH/EXIT', 'STAGE', 'SOUTH', 'WEST'];

  const mainRoomSlides = [
    { id: 1, content: <MainNorth /> }, 
    { id: 2, content: <NorthExit /> }, 
    { id: 3, content: <Stage /> }, 
    { id: 4, content: <MainSouth /> }, 
    { id: 5, content: <MainWest /> },
  ];


  const handleNext = useCallback(() => {
    if (activePageIndex === pages.length - 1) {
      goTo(0);
    } else {
      next();
    }
  }, [activePageIndex, pages.length, goTo, next]);

  const handlePrev = useCallback(() => {
   if (activePageIndex === 0) {
      goTo(pages.length - 1);
   } else {
      prev();
   }
  }, [activePageIndex, pages.length, goTo, prev]);
  
  return (
    <div key={location.index} className="page-fade-in carousel-container">
      <div className="controls-bar">
        <div className="dropdown">
          <Dropdown />
        </div>
        <div className="controls">
          {/* ----------- < Previous Button ---------- */}
          <button className="arrow" onClick={handlePrev}>
            <FaAngleLeft />
          </button>

          { /* -------- Pagination -------- */}
          <div className="labels-container">
            {labels.map((word, i) => (
              <button 
                key={i} 
                onClick={() => goTo(i)}
                className={`page-button ${activePageIndex === i ? 'active-button' : ''}`}
              >
                {word}
              </button>
            ))}
          </div>
          {/* ----------- Next Button ---------- */}
          <button className="arrow" onClick={handleNext}>
            <FaAngleRight />
          </button>
        </div>
        <div className="screen-toggle-button">
          <ScreenToggleButton />
        </div>
      </div>
      <ul ref={scrollRef} className="gallery-container">
        {mainRoomSlides.map((item) => (
          <div key={item.id} className="wall-item">
            {item.content}
          </div>
        ))};
      </ul> 
    </div>
  );
};

export default MainRoom;